import { useTranslation } from 'react-i18next';
import { routes } from '@platform/core/lib/routes';
import { recordNumber } from '@platform/engine/views/recordNumber';
import { useSince } from '@platform/features/users/inbox/useSince';
import { WorkspaceLink } from '@platform/navigation';
import { feedText } from './feedText';
import type { IActivityFeedRowProps } from './IActivityFeedRowProps';
import { initials } from './initials';

/**
 * Рядок «Нещодавньої активності» зі стрічки простору (прототип v4 G:L1572): ініціали автора в колі 24px, «<b>Хто</b> що зробив» (feedText:
 * «змінено «Статус» на «В роботі»», «прокоментував(-ла)», «пов’язано з 9») і під ним 11px «номер · назва · коли» (голий номер, як у
 * прототипі: «101 · Назва · щойно»); рядок відкриває запис.
 */
export function ActivityFeedRow({ item }: IActivityFeedRowProps) {
  const { t } = useTranslation();
  const since = useSince();
  const who = item.actor?.name ?? '';
  const r = item.record;
  const to = r.id && r.module && r.recordType ? routes.record(r.module, r.recordType, r.id) : routes.home();
  return (
    <WorkspaceLink className="hp-act" ws={r.workspaceId} to={to}>
      <span className="hp-act__avatar" aria-hidden="true">{item.actor?.initials || initials(who)}</span>
      <span className="hp-act__text">
        <span className="hp-act__title"><b>{who}</b> {feedText(item, t)}</span>
        <span className="hp-act__meta" title={r.display ?? undefined}>{[recordNumber({ code: r.code ?? 0, display: r.display ?? '' }), r.title, since(item.at)].filter(Boolean).join(' · ')}</span>
      </span>
    </WorkspaceLink>
  );
}
